import { Component, Input } from '@angular/core';
import { BankCustomizationData, BankLogoDisplayOption } from '../../api/session/session.service';
import { environment } from '../../../environments/environment';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'pin-bank-logo',
    templateUrl: './bank-logo.component.html',
    imports: [MatDivider]
})
export class BankLogoComponent {

  @Input()
  bankName: string;
  @Input()
  bankCustomizationData: BankCustomizationData;
  isLogoValid = true;

  getLogoUrl(): string {
    const logoFileName = this.bankCustomizationData?.logoFileName;
    return logoFileName
      ? `${environment.institutionLogoUrl}/${encodeURIComponent(logoFileName)}`
      : '';
  }

  showLogo(): boolean {
    return !!this.bankCustomizationData?.logoFileName && this.isLogoValid;
  }

  setLogoInvalid(): void {
    this.isLogoValid = false;
  }

  showBankName(): boolean {
    return !this.bankCustomizationData?.logoFileName
      || this.bankCustomizationData?.logoDisplayOption === BankLogoDisplayOption.LOGO_WITHOUT_INSTITUTION_NAME
      || !this.isLogoValid;
  }
}
